import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-company-details',
  templateUrl: './company-details.component.html',
  styleUrls: ['./company-details.component.scss']
})
export class CompanyDetailsComponent implements OnInit {
  offices = [
    {
      title: 'Dubai Office',
      entity: 'Onixhu LLC',
      lines: [
        'DFHQ, 25 Hours Heimat',
        'Trade Centre Second, Downtown',
        'Dubai, UAE'
      ]
    },
    {
      title: 'Sharjah Office',
      entity: 'Onixhu LLC',
      lines: [
        'SHAMS',
        'Sharjah, UAE'
      ]
    }
  ];

  ngOnInit(): void {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
}
